export const errorTypes = {
  unavailableMaterialInThickness: "Company can't produce this part.",
  noApplicableMaterial: "Company doesn't have an available material to produce this.",
  noSimpleMachining: "Company doesn't provide machining services.",
  tooThickForMachining: "Part thickness is too big for production.",
  noPlate: "No available sheet",
  noMaterial: "Material not available"
}